
import { blobToBase64, base64toFile } from "./fileConvert";
// import ImageCompressor from 'image-compressor.js'
import Compressor from 'compressorjs';
import { ElMessage } from 'element-plus'
import { Promise } from 'core-js'
//生成一个input标签
var input = document.createElement('input');
input.style.display = 'none';
input.type = "file";
input.accept = "image/*";
//创建一个画布，上下文
var imgCanvas = document.createElement('canvas');
var imgContext = imgCanvas.getContext('2d');
//选择一个图片文件（并压缩）


export function selectImage(ops, callback) {
     ops = ops || {
          maxWidth: 1536,
          maxHeight: 1536,
     };

     //触发点击事件
     input.click();
     //回调函数
     input.onchange = async function (e) {
          if (this.files.length > 0) {
               let imgFile = this.files[0];
               // console.dir(imgFile);
               //尝试压缩
               let compressorImg = await tryCompress(imgFile,ops);
               if (!compressorImg) {
                    //正常压缩失败，将图片标准化之后再压缩
                    let standardizeImg = await standardizeImgFile(imgFile);
                    compressorImg = await tryCompress(standardizeImg);
               }
               if (compressorImg) {
                    callback && callback(compressorImg);
               }
               else {
                    //图片无法压缩
                    ElMessage.error('compress error,please try another image.');
               }
          }

          this.value = null;
     };
}

//尝试压缩文件
function tryCompress(imgFile,ops) {
     return new Promise((resolve, reject) => {
          //压缩文件
          new Compressor(imgFile, {
               quality: 0.6,
               maxWidth: ops.maxWidth,
               maxHeight: ops.maxHeight,
               success(compressorImg) {
                    resolve(compressorImg);
               },
               error(err) {
                    resolve(undefined);
               },
          })
     })
}
//标准化图片文件(标准化文件可以解决很多兼容性的问题)
function standardizeImgFile(file) {
     var maxWidth = 512;
     var maxHeight = 512;
     return new Promise((resolve, reject) => {
          blobToBase64(file, function (base64) {
               //console.log(file);
               var image = new Image();
               image.src = base64;
               image.onload = function () {
                    var width = image.width;
                    var height = image.height;
                    var scale = 1;
                    //保证图片不要太大
                    if (maxWidth / width < scale) {
                         scale = maxWidth / width;
                    }
                    if (maxHeight / height < scale) {
                         scale = maxWidth / width;
                    }
                    imgCanvas.width = width * scale;
                    imgCanvas.height = height * scale;
                    imgContext.drawImage(image, 0, 0, imgCanvas.width, imgCanvas.height);
                    var newBase64 = imgCanvas.toDataURL();
                    var standardizeImg = base64toFile(newBase64, file.name);
                    resolve(standardizeImg);
               };
          })
     })

}
